/* IMPORTS */
import { MeasurementList } from "./MeasurementList";
import gettext from "../../../shared/utils/gettext";
import React, { useCallback } from "react";
import "./CorrelationStyling.css";
import { LayerProps, MeasurementTypes, SelectedDatasetMeasurementsTypes } from "./ObjectInterfaces";
import { useCorrectMeasurements } from "./util";

/* CropfieldLayer Component */
export const CropfieldLayer = ({
  dataset,
  measurements,
  layer,
  selectedMeasurements,
  setSelectedMeasurements,
  setNumOfMeasurements,
}: LayerProps) => {
  const correctMeasurements = useCorrectMeasurements(measurements, setNumOfMeasurements);

  /* Button handler selecting all the unselected measurements from a dataset */
  const handleSelectAll = useCallback(
    (e) => {
      e.preventDefault();
      const allSelectedMeasurements = { ...selectedMeasurements };
      let measurementObject: SelectedDatasetMeasurementsTypes =
        allSelectedMeasurements[dataset.uuid];
      for (let i: number = 0; i < correctMeasurements.length; i++) {
        let measurement: MeasurementTypes = correctMeasurements[i];
        /* If measurements from the dataset have already been selected, simply add the unselected ones */
        if (measurementObject) {
          if (
            !measurementObject.indexes.includes(measurement.index) ||
            !measurementObject.names.includes(measurement.name)
          ) {
            measurementObject.indexes.push(measurement.index);
            measurementObject.names.push(measurement.name);
            measurementObject.codes.push(measurement.code);
            measurementObject.displayNames.push(measurement.display_name!);
          }
          /* If no measurements from the dataset have been selected, create a new object */
        } else {
          measurementObject = {
            indexes: [measurement.index],
            names: [measurement.name],
            codes: [measurement.code],
            displayNames: [measurement.display_name!],
            layerId: layer.id,
          };
        }
      }
      allSelectedMeasurements[dataset.uuid] = measurementObject;
      setSelectedMeasurements(allSelectedMeasurements);
    },
    [correctMeasurements, dataset.uuid, layer.id, setSelectedMeasurements, selectedMeasurements]
  );

  /* JSX */
  return (
    <div className="card-list-item pt-1 border-dash" key={layer.id}>
      <span
        className="parcel-image"
        dangerouslySetInnerHTML={{
          __html: layer.cropfield.getImageTag({ size: 24, class: "left" }),
        }}
        onClick={handleSelectAll}
      />
      <a href="." onClick={handleSelectAll} className="select-all-button">
        {gettext("Select all measurements")}
      </a>

      <MeasurementList
        dataset={dataset}
        layer={layer}
        measurements={correctMeasurements}
        selectedMeasurements={selectedMeasurements}
        setSelectedMeasurements={setSelectedMeasurements}
      />
    </div>
  );
};
